export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "iban_extraction_extracting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lecture automatique de l'IBAN en cours..."])},
        "iban_extraction_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La lecture automatique a échoué. Veuillez saisir l'IBAN manuellement."])},
        "iban_extraction_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'IBAN a été pré-rempli automatiquement. Veuillez vérifier son exactitude."])}
      },
      "en": {
        "iban_extraction_extracting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Automatically reading the IBAN..."])},
        "iban_extraction_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Automatic reading failed. Please enter the IBAN manually."])},
        "iban_extraction_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The IBAN was pre-filled automatically. Please check it is correct."])}
      }
    }
  })
}
